import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom';
import feather from 'feather-icons';
import serverClient from '../api/ServerClient';
import Loader from '../components/Loader';
import Alert from '../components/Alert';
import { useLanguage } from '../context/LanguageContext';
import { getPageMeta } from '../util/seoHelper';

const ForgetPassword = () => {
    const navigate = useNavigate();
    const { t, language } = useLanguage();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [otp, setOtp] = useState('');
    const [otpSent, setOtpSent] = useState(false); // step control

    useEffect(() => {
        feather.replace();
    }, []);

    const [recipientEmail, setRecipientEmail] = useState('');

    const handleEmailChange = (e) => {
        setRecipientEmail(e.target.value);
    };

    const handleOtpChange = (e) => {
        setOtp(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (!otpSent) {
                const response = await serverClient.post(`/api/auth/send-otp`, {
                    recipientEmail,
                });

                if (response.status === 200) {
                    setError('');
                    setOtpSent(true);
                }
            } else {
                const response = await serverClient.post(`/api/auth/verify-otp`, {
                    recipientEmail,
                    otp,
                });

                if (response.status === 200) {
                    navigate('/reset-password', {
                        state: {
                            email: recipientEmail,
                            token: otp,
                        },
                    });
                }
            }
        } catch (err) {
            if (!err?.response) {
                setError(t('noServerResponse'));
            } else if (err.response?.status === 400) {
                setError(t('invalidInputData'));
            } else if (err.response?.status === 404) {
                setError(t('emailNotFound'));
            } else {
                setError(t('tryAgainLater'));
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-body">
            <Helmet>
                <title>{getPageMeta('forgotPassword', language).title}</title>
                <meta
                    name="description"
                    content={getPageMeta('forgotPassword', language).description}
                />
                <meta name="keywords" content={getPageMeta('forgotPassword', language).keywords} />
                <link rel="canonical" href={getPageMeta('forgotPassword', language).url} />
                {getPageMeta('forgotPassword', language).noindex && (
                    <meta name="robots" content="noindex, follow" />
                )}
            </Helmet>
            <div className="auth-header">
                <Link to="/login">
                    <i className="back-btn" data-feather="arrow-left"></i>
                </Link>

                <img
                    className="img-fluid img"
                    src={'assets/images/authentication/3.svg'}
                    alt="v1"
                />

                <div className="auth-content">
                    <div>
                        <h2>{t('forgetPassword')}</h2>
                        <h4 className="p-0">{t('forgetPasswordSubtitle')}</h4>
                    </div>
                </div>
            </div>
            <Loader loading={loading} />

            {/* Form */}
            <form className="auth-form" onSubmit={handleSubmit} target="_blank">
                <div className="custom-container">
                    <div className="form-group">
                        {error && <Alert alert={'danger'}> {error} </Alert>}

                        <h6 id={'forget-password-text'}>
                            {otpSent ? t('otpVerification') : t('resetPasswordEmail')}
                        </h6>
                        <label htmlFor="recipientEmail" className="form-label">
                            {t('email')}
                        </label>
                        <div className="form-input">
                            <input
                                type="email"
                                className="form-control"
                                id="recipientEmail"
                                placeholder={t('enterEmail')}
                                value={recipientEmail}
                                onChange={handleEmailChange}
                            />
                        </div>

                        {otpSent && (
                            <>
                                <label htmlFor="otp" className="form-label mt-3">
                                    {t('enterOTP')}
                                </label>
                                <div className="form-input">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="otp"
                                        placeholder={t('enterOTP')}
                                        value={otp}
                                        onChange={handleOtpChange}
                                    />
                                </div>
                            </>
                        )}
                    </div>

                    <button type="submit" className="btn theme-btn w-100">
                        {otpSent ? t('submitOTP') : t('sendOTP')}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ForgetPassword;
